import MobileVersion from "./MobileVersion";

export default MobileVersion;
